export default "__VITE_ASSET__7Zdo29hw__"